// extracted by mini-css-extract-plugin
export default {"buttonDesktop":"styles_buttonDesktop__oJssm","buttonMobile":"styles_buttonMobile__pVdo6","selected":"styles_selected__0NRdk"};